import Item from "./Item";

const List = (props)=>
{
  const {items, removeItem, editItem} = props;
  return (
  <div className="grocery-list">
    {
      items.map((item)=>
      {
        return <Item {...item} key = {item.id} removeItem = {removeItem} editItem = {editItem} />;
      })
    }
  </div>);
}

export default List;